/**
 * SenritsuX FAQ Data
 * Single source of truth for all FAQ content.
 * Used by FaqPage.jsx (accordion) and FaqDetailPage.jsx (individual pages).
 *
 * slug: URL-safe identifier for /faq/:slug routing.
 * Do NOT change slugs after launch ,  they are canonical URLs.
 */

export const FAQ_CATEGORIES = [
  'All',
  'Music Distribution',
  'Royalties & Payouts',
  'Rights & Ownership',
  'Release Management',
  'Artist WEB & Collabs',
];

export const faqs = [
  {
    slug: 'which-streaming-platforms',
    category: 'Music Distribution',
    question: 'Which streaming platforms does SenritsuX distribute to?',
    answer:
      'SenritsuX delivers your music to 150+ major streaming services and digital stores worldwide, including Spotify, Apple Music, JioSaavn, Wynk Music, Amazon Music, YouTube Music, Instagram & Facebook Audio Library, TikTok, Shazam, Tidal, and Deezer.',
  },
  {
    slug: 'how-long-release-go-live',
    category: 'Music Distribution',
    question: 'How long does it take for my release to go live on streaming platforms?',
    answer:
      'Once submitted, our quality-assurance team reviews your audio metadata and artwork within 24 to 48 hours. Most releases go live on Spotify and Apple Music within 2 to 5 business days. For planned release dates, we recommend submitting at least 2 weeks in advance to allow playlist editorial pitching.',
  },
  {
    slug: 'retain-100-master-rights',
    category: 'Rights & Ownership',
    question: 'Do I retain 100% of my master rights and copyright?',
    answer:
      'YES! Absolutely 100%. SenritsuX is strictly an artist-first ecosystem. You never sign away your master rights or publishing copyright. You have complete freedom to remove, transfer, or re-license your releases at any time without punitive exit fees.',
  },
  {
    slug: 'royalty-payouts',
    category: 'Royalties & Payouts',
    question: 'How much royalty do I keep, and how are payouts processed?',
    answer:
      'Depending on your distribution plan, you keep up to 97.5% of all streaming and download royalties earned across all platforms. Payouts are updated monthly as DSP reporting arrives and can be withdrawn directly via UPI, Indian Netbanking (NEFT/IMPS), or International wire transfer without unnecessary holding periods.',
  },
  {
    slug: 'audio-artwork-formats',
    category: 'Release Management',
    question: 'What audio and artwork formats are required for music distribution?',
    answer:
      'Audio must be stereo WAV format (16-bit or 24-bit, 44.1 kHz or higher). Artwork must be a high-resolution square JPEG/PNG of exactly 3000x3000 pixels without blurred logos, pricing, or unauthorized trademarks.',
  },
  {
    slug: 'playlist-pitching',
    category: 'Release Management',
    question: 'How does playlist pitching and DSP editorial promotion work?',
    answer:
      'When you submit releases at least 10 to 14 days ahead of release date, our team pitches your track to Spotify, Apple Music, and Amazon Music editorial curators, along with our verified independent curator network.',
  },
  {
    slug: 'artist-web-directory',
    category: 'Artist WEB & Collabs',
    question: 'What is SenritsuX Artist WEB?',
    answer:
      'Artist WEB is our verified creator platform where singers, rappers, producers, sound engineers, and visual directors build public portfolio profiles (e.g., senritsux.in/artist/your-name). Artists can discover one another, send verified collaboration proposals, and build an authentic indie community.',
  },
  {
    slug: 'cover-songs-remixes-samples',
    category: 'Music Distribution',
    question: 'Can I distribute cover songs, remixes, or tracks with samples?',
    answer:
      'You can distribute cover songs provided you obtain a mechanical license or use our licensing partners. For samples, you must hold documented permission from the original master and publishing rights holders before submitting to prevent copyright strikes on DSPs.',
  },
  {
    slug: 'hidden-fees',
    category: 'Royalties & Payouts',
    question: 'Are there any hidden fees or annual takedown penalties?',
    answer:
      'No hidden fees. We believe in total financial transparency. We do not charge surprise maintenance fees, hidden upload taxes, or takedown penalties when you wish to unpublish your music.',
  },
  {
    slug: 'verified-star-badges',
    category: 'Artist WEB & Collabs',
    question: 'How do I earn verified star badges on my artist profile?',
    answer:
      'Verified star badges (1 to 5 stars) are awarded by the SenritsuX curation committee based on streaming performance milestones, production catalog depth, account authenticity, and active community collaboration.',
  },
  {
    slug: 'how-senritsux-works',
    category: 'Music Distribution',
    question: 'How does SenritsuX work for independent music creators?',
    answer:
      'SenritsuX is an end-to-end music distribution and artist services ecosystem. You create an account, upload your uncompressed stereo WAV audio and 3000x3000px cover artwork, provide release details, and submit. Our team reviews and delivers your music to 150+ streaming platforms like Spotify, Apple Music, and JioSaavn. You keep 100% master rights and earn up to 97.5% royalties, while using Artist WEB to build your public portfolio and collaborate.',
  },
];

/**
 * Get a single FAQ item by its slug.
 * Returns undefined if not found.
 */
export function getFaqBySlug(slug) {
  if (!slug) return undefined;
  return faqs.find((f) => f.slug === slug.toLowerCase().trim());
}
